import PropTypes from "prop-types"
import classNames from "classnames"
import { track } from "helpers/analytics"
import ExternalLinks from "components/link"
import { BUTTONS, SUMMARY } from "../shapes"
import { TRACKING_EVENTS } from "../constants"
import MarkdownSummary from "./markdown-summary"
import Toolbar from "./toolbar"

export default function Summary({ isGenerated, summary, error, summaryButtons, isGeneratedByAI, className }) {
  const handleLinkClick = (url, linkText) => {
    track(TRACKING_EVENTS.EXTERNAL_LINK_CLICKED, {
      url,
      linkText,
    })
  }

  return <div className={classNames("content", className)}>
    <div className="summary">
      <ExternalLinks onLinkClick={handleLinkClick}>
        <MarkdownSummary {...{ isGenerated, summary, error }} />
      </ExternalLinks>
    </div>
    <div className="footer">
      {(isGenerated || error) && <Toolbar id="summary-toolbar" buttons={summaryButtons} />}
      <div className="disclaimer">
        {isGeneratedByAI ? "Generated by AI. " : ""}Any information provided is not investment advice.
      </div>
    </div>
  </div>
}

Summary.propTypes = {
  isGenerated: PropTypes.bool,
  summary: SUMMARY,
  error: PropTypes.string,
  summaryButtons: BUTTONS,
  isGeneratedByAI: PropTypes.bool,
  className: PropTypes.string,
}
